webpackJsonp([12],{

/***/ "./scroll-nav.js":
/***/ (function(module, exports) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// visibleOffset: Sometimes the bottom of an element is just empty white space, so it's weird when that element's nav
// item is selected instead of the next item. visibleOffset makes each element effectively start `x` pixels before its
// actual start position, so it can be selected as topmost instead of the element preceding it
window.aboundScrollNav = function (_ref) {
    var linkEls = _ref.linkEls,
        currentClass = _ref.currentClass,
        _ref$defaultTarget = _ref.defaultTarget,
        defaultTarget = _ref$defaultTarget === undefined ? null : _ref$defaultTarget,
        _ref$updateUrl = _ref.updateUrl,
        updateUrl = _ref$updateUrl === undefined ? true : _ref$updateUrl,
        _ref$visibleOffset = _ref.visibleOffset,
        visibleOffset = _ref$visibleOffset === undefined ? 50 : _ref$visibleOffset;

    var throttle = function throttle(ms, f) {
        var lastCallStamp = null;
        var lastResult = null;

        return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var now = new Date().getTime();

            // don't do anything
            if (lastCallStamp !== null && now - lastCallStamp < ms) return lastResult;

            lastCallStamp = now;
            lastResult = f.apply(null, args);

            return lastResult;
        };
    };

    var getElByTarget = function getElByTarget(targetStr) {
        return document.getElementById(targetStr.replace('#', ''));
    };

    var getLinkByTarget = function getLinkByTarget(linkEls, targetStr) {
        return linkEls.reduce(function (acc, linkEl) {
            return linkEl.getAttribute('target') === targetStr ? linkEl : acc;
        }, null);
    };

    var isVisible = function isVisible(el) {
        var rect = el.getBoundingClientRect();

        return rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
    };

    var getLinkElByTopmostVisibleTarget = function getLinkElByTopmostVisibleTarget(linkEls, defaultTarget) {
        var topmostEl = [].concat(_toConsumableArray(linkEls)).reduce(function (acc, linkEl) {
            var href = linkEl.getAttribute('href');
            var targetEl = getElByTarget(href);

            if (!targetEl) return acc;
            if (!isVisible(targetEl)) return acc;

            var rect = targetEl.getBoundingClientRect();

            // adjust the element's start position by its CSS scroll-margin-top and the visibleOffset
            var computedStyle = window.getComputedStyle(targetEl),
                scrollMarginTopValue = computedStyle.getPropertyValue('scroll-margin-top'),
                elTop = rect.top - parseFloat(scrollMarginTopValue) - visibleOffset;

            // return the last element with a negative elTop, i.e. it started above the viewport
            return acc.el === null || elTop <= 0 ? { el: linkEl, elTop: elTop } : acc;
        }, { el: null, elTop: 0 }).el;

        return topmostEl === null && defaultTarget ? getLinkByTarget(linkEls, defaultTarget) : topmostEl;
    };

    var updateLinks = function updateLinks() {
        var currentLinkEl = getLinkElByTopmostVisibleTarget(linkEls);

        linkEls.forEach(function (el) {
            return el.classList.remove(currentClass);
        });

        if (currentLinkEl) {
            var href = currentLinkEl.getAttribute('href');
            currentLinkEl.classList.add(currentClass);

            if (updateUrl && window.location.hash !== href) {
                history.replaceState(null, null, href);
            }
        } else if (updateUrl) {
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    };

    window.addEventListener('scroll', throttle(100, updateLinks));

    // run once on initial load
    updateLinks();
};

/***/ })

},["./scroll-nav.js"]);


// WEBPACK FOOTER //
// scripts/scroll-nav.47d1c49dd606c57f9c02.js